import { render, staticRenderFns } from "./PositionManagement.vue?vue&type=template&id=de664cc4&"
import script from "./PositionManagement.vue?vue&type=script&lang=js&"
export * from "./PositionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports